import axios from 'axios';
import { getAPIHost, getExpressAPIHost } from '../../utils';
import Split from '../split';

const uploadFile = (formData) =>
    new Promise((resolve, reject) => {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const host = useExpress ? getExpressAPIHost() : getAPIHost();
        // Split-gate both host AND path: Express uses /s3/file-upload;
        // LoopBack uses the un-namespaced /file-upload.
        const path = useExpress ? '/s3/file-upload' : '/file-upload';
        axios
            .post(`${host}${path}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                // Express returns { keys: [{ key, name, url, type }] }
                // LoopBack returns the upload result directly
                if (useExpress && response.data && response.data.keys && response.data.keys.length > 0) {
                    resolve({ ...response, data: { key: response.data.keys[0].key } });
                } else {
                    resolve(response);
                }
            })
            .catch(() => {
                reject(new Error('Unable to upload file'));
            });
    });

export default uploadFile;
